import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// Toast duration set to 2 seconds (2000ms) globally
const TOAST_DURATION = 2000;

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      {...props}
      theme={theme}
      className="toaster group"
      position="bottom-right"
      duration={TOAST_DURATION}
      closeButton={true}
      richColors={false}
      expand={false}
      visibleToasts={3}
      toastOptions={{
        duration: TOAST_DURATION,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
    />
  );
}

export { Toaster, toast }
